<template>
  <!-- 聚能谷微信用户充值费空表 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="分支箱">
        <el-input placeholder="请输入分支箱名" v-model="filter.branch_box_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="通道">
        <el-input placeholder="请输入通道号" v-model="filter.gunNo" clearable @input="handleInput" style="width: 130px"></el-input>
      </el-form-item>
      <el-form-item label="电表地址">
        <el-input placeholder="请输入电表地址" v-model="filter.fee_table_address" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="所属分支箱" prop="branch_box_name" align="center"></el-table-column>
      <el-table-column label="资产码" prop="assets_code" align="center"></el-table-column>
      <el-table-column label="电表地址" prop="feetable_address" width="120" align="center"></el-table-column>
      <el-table-column label="通道" prop="gun_no" width="60" align="center"></el-table-column>
      <el-table-column label="充值金额" prop="recharge_money" width="100" align="center"></el-table-column>
      <el-table-column label="微信昵称" prop="wx_nick_name" align="center"></el-table-column>
      <el-table-column label="状态" prop="status_name" align="center" width="120">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.recharge_status == 10"> 充值成功 </el-tag>
          <el-tag type="danger" v-else-if="row.recharge_status == 0">充值中</el-tag>
          <div v-else>
            <el-tag type="info" v-if="row.wxpay_return == 1">已退款</el-tag>
            <el-tag type="danger" v-else-if="row.wxpay_return == 2">退款失败</el-tag>
            <el-tag type="danger" v-else>充值失败 </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" align="center" width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <div class="statistic_left">
        <span class="sbox">
          充值成功： <span class="bold ssuc">{{ statistic.chargeSuc }}元</span>
        </span>
        <span class="sbox">
          充值失败：<span class="bold sfail">{{ statistic.chargeFail }}元</span>
        </span>
        <span class="sbox">
          已退款：<span class="bold sreturn"> {{ statistic.returnSuc }}元</span>
        </span>
      </div>
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="预充值详情" width="760px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
          <el-col :span="12">
            <el-form-item label="数据编号" prop="ID">
              <el-input v-model="detailForm.ID" readonly disabled />
            </el-form-item>
            <el-form-item label="费控表地址" prop="feetable_address">
              <el-input v-model="detailForm.feetable_address" readonly disabled />
            </el-form-item>
            <el-form-item label="通道号" prop="gun_no">
              <el-input v-model="detailForm.gun_no" readonly disabled />
            </el-form-item>
            <el-form-item label="微信唯一编号" prop="union_id"> <el-input v-model="detailForm.union_id" readonly disabled /> </el-form-item>
            <el-form-item label="微信昵称" prop="wx_nick_name">
              <el-input v-model="detailForm.wx_nick_name" readonly disabled />
            </el-form-item>
            <el-form-item label="状态" prop="create_time">
              <el-tag type="success" v-if="detailForm.recharge_status == 10"> 充值成功 </el-tag>
              <el-tag type="danger" v-else-if="detailForm.recharge_status == 0">充值中</el-tag>
              <div v-else>
                <el-tag type="info" v-if="detailForm.wxpay_return == 1">已退款</el-tag>
                <el-tag type="danger" v-else-if="detailForm.wxpay_return == 2">退款失败</el-tag>
                <el-tag type="danger" v-else>充值失败 </el-tag>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="充值金额" prop="recharge_money">
              <el-input v-model="detailForm.recharge_money" readonly disabled />
            </el-form-item>
            <el-form-item label="所属分支箱" prop="branch_box_name">
              <el-input v-model="detailForm.branch_box_name" readonly disabled />
            </el-form-item>
            <el-form-item label="微信订单号" prop="wx_order_no">
              <el-input v-model="detailForm.wx_order_no" readonly disabled />
            </el-form-item>
            <el-form-item label="聚能谷订单号" prop="jng_order_no">
              <el-input v-model="detailForm.jng_order_no" readonly disabled />
            </el-form-item>
            <el-form-item label="创建时间" prop="create_time">
              <el-input v-model="detailForm.create_time" readonly disabled />
            </el-form-item>
            <el-form-item label="设备返回时间" prop="balance_recharge_time">
              <el-input v-model="detailForm.balance_recharge_time" readonly disabled />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row type="flex" justify="center"> <el-button type="primary" v-if="detailForm.balance_recharge_reason != 10 && detailForm.wxpay_return == 0" @click="onReturnMoney(detailForm)">退款</el-button></el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetRechargePageList, WxReturnMoney, GetRechargeStatisticInfo } from "@/api/dev_fee_table"
import { mapGetters } from "vuex"
export default {
  name: "JngWxuserRechargeFeetable",
  mixins: [pageMixin],
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      tableData: [],
      filter: {
        assets_code: "",
        union_id: "",
        dateRange: [], // 使用一个数组来同时存储开始和结束时间
        branch_box_name: "",
        fee_table_address: "",
        gunNo: ""
      },
      statistic: {
        chargeSuc: 0, //充值成功
        chargeFail: 0, //充值失败
        returnSuc: 0 //已退款
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
    this.GetStatisticInfo()
  },
  methods: {
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    onReturnMoney(row) {
      this.loading = true
      WxReturnMoney({ orderid: row.jng_order_no })
        .then((res) => {
          this.getData()
          this.detailVisible = false
        })
        .finally(() => {
          this.loading = false
        })
    },

    toFilter() {
      this.pageParams.page = 1
      this.getData()
      this.GetStatisticInfo()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },
    getData() {
      this.loading = true
      GetRechargePageList(this.GetParams())
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    GetStatisticInfo() {
      GetRechargeStatisticInfo(this.GetParams())
        .then((res) => {
          this.statistic.chargeSuc = res.statistic.Item1
          this.statistic.chargeFail = res.statistic.Item2
          this.statistic.returnSuc = res.statistic.Item3
        })
        .finally(() => {
          this.loading = false
        })
    },
    GetParams() {
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        start_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[0],
        end_time: (!this.filter.dateRange || this.filter.dateRange.length == 0) ? "" : this.filter.dateRange[1],
        assets_code: this.filter.assets_code || null,
        branch_box_name: this.filter.branch_box_name || null,
        fee_table_address: this.filter.fee_table_address || null,
        gunNo: this.filter.gunNo || null
      }
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
